import React, { useContext, useState, useLayoutEffect } from 'react';

import * as S from './styles';
import { tabsList } from './listTabsflag';
import TabsMaterial from 'components/TabsMaterial';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
import DataFormStoriesCarousel from 'components/DataFormStoriesCarousel';
import AddStoriesInList from 'components/AddStoriesInList';
import { DataFormProps } from 'types/InputsStoriesCarouselProps';

const initialData: DataFormProps = {
	paddingBottom: 0,
	paddingTop: 0,
	schedule: {
		countdown: false,
		end: '',
		start: '',
		timezone: 'America/Sao_Paulo'
	},
	size: 0,
	square: false,
	stories: [],
	title: ''
};

export default function InputsStoriesCarousel() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		setModuleOnPhoneToEdit,
		moduleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [tabSelected, setTabSelected] = useState(0);
	const [dataForm, setDataForm] = useState(initialData);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);
		}
	}, []);

	return (
		<S.container>
			<TabsMaterial listTabs={tabsList} getPage={setTabSelected} />

			<S.content>
				<DataFormStoriesCarousel
					dataForm={dataForm}
					setDataForm={setDataForm}
					isShow={tabSelected === 0}
				/>
				<AddStoriesInList
					isShow={tabSelected === 1}
					dataForm={dataForm}
					setDataForm={setDataForm}
				/>
			</S.content>
		</S.container>
	);
}
